module.exports = __webpack_public_path__ + "static/img/icon_3.1908e8d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon/icon_3.png
// module id = lJyH
// module chunks = 49